<template lang="pug">
  .component-credit-records
    ActionBar
      h2(slot="title") {{type}} Credit
      i.fa.fa-plus-circle.fa-2x(slot="action", v-if="expanded", @click="addCredit = !addCredit")
      i.fa.fa-2x(slot="action", :class="{'fa-eye-slash':expanded, 'fa-eye':!expanded}", @click="expanded = !expanded")
    .add-credit(v-if="addCredit")
      .row
        .column
          label Amount Vat Included
            input(type="number" v-model="body.amount")
          label Reason
            input(type="text", v-model="body.reason")
        .column
          label Tax
            input(type="number", v-model="body.tax")


          label Service
            select(v-model="body.service")
              option(:value="null") All
              option Reservation
              option Subscription
      .row
        .column
          label Valid from
            DatePicker(v-model="body.valid_from")
        .column
          label Valid to
            DatePicker(v-model="body.valid_to")
      ActionButton(:action="addNewCredit") Add Credit
      // button.button Add credit
    base-list(ref="listCr", v-if="expanded", :component="component", :search="search", :dataLoader="dataLoader", :resultsPerPage="5", componentType="listing")


</template>

<script>
  import KeplerBackofficeSdk from '../../../lib/kepler/backoffice'
  import BaseList from '../../../pages/backoffice/BaseList'
  import ActionBar from '../../structure/ui/ActionBar'
  import DatePicker from '../../structure/DatePicker'
  import ActionButton from '../../structure/ui/ActionButton'

  export default {
    name: 'TabbedCreditRecords',
    components: {ActionButton, DatePicker, ActionBar, BaseList},
    data() {
      return {
        component: require('src/components/backoffice/CreditRecord'),
        expanded: true,
        addCredit: false,
        body: {
          amount: 0,
          tax: null,
          reason: null,
          type: this.type.toUpperCase(),
          service: null,
          valid_from: null,
          valid_to: null,
        }
      }
    },
    created() {
    },
    mounted() {
      this.body.tax = this.$defaultVat()
    },
    methods: {
      dataLoader(callback, page = 1, resultsPerPage = 5) {
        KeplerBackofficeSdk.credits.list.all(this.search, page, resultsPerPage, (data) => {
          callback(data)
        })
      },
      addNewCredit() {
        const body = {
          ...this.body,
          client_id: this.$route.params.id,
          tax: this.body.tax / 100,
        }
        return KeplerBackofficeSdk.credits.make(body, () => {
          this.$refs.listCr.loadData(1)
        })
      },
    },
    computed: {
      search() {
        return {
          client_id: this.$route.params.id,
          type: this.type
        }
      }
    },
    props: ['type']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CreditRecords.vue?6b317963